import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    FormControlLabel,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { IModalPayload } from "../../constants/common-interface";
import { IOption, IURLLoaderConfig } from "../../constants/model-interfaces";
import FormContext from "../form-context";
import VirtualScroll from "react-dynamic-virtual-scroll";

const MuiModal = (props: IProps) => {
    const formContext = useContext(FormContext);
    const [isLoading, setLoading] = useState(false);
    const [options, setOptions] = useState<Array<IOption>>([]);
    const [period, setPeriod] = useState<any>(-1);

    const searchIcon = formContext.getIcon("search");
    const wrapperClassName = "meta-search-dialog-" + props.payload?.field;

    const handleClose = () => {
        props.onClose();
        setOptions([]);
    };

    useEffect(() => {
        if (props.open && props.payload?.options.length === 0) {
            // load options first time
            setLoading(true);
            props.payload?.config &&
                formContext
                    .getData(props.payload?.config, "", props.payload?.section, "$initial")
                    .then((results: Array<IOption>) => {
                        setOptions(results);
                        setLoading(false);
                    })
                    .catch(() => {
                        setOptions([]);
                        setLoading(false);
                    });
        } else {
            setOptions(props.payload?.options || []);
            setLoading(false);
        }
    }, [props.payload?.options]);

    return (
        <Dialog fullScreen open={props.open} className={wrapperClassName}>
            <Box>
                <Button
                    className='close-btn'
                    variant='text'
                    onClick={() => {
                        handleClose();
                    }}
                    sx={{ float: "right" }}
                >
                    Close
                </Button>
            </Box>
            <Box className='meta-search-input-wrapper' sx={{ padding: "16px" }}>
                <TextField
                    autoComplete='off'
                    className='meta-search-input'
                    fullWidth
                    label={props.payload?.label}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='start'>
                                <IconButton>{searchIcon}</IconButton>
                            </InputAdornment>
                        )
                    }}
                    placeholder='Search'
                    onChange={(e) => {
                        const value = e.target.value;
                        if (props.payload?.config) {
                            setLoading(true);
                            clearTimeout(period);
                            const timeout = setTimeout(() => {
                                props.payload?.config &&
                                    formContext
                                        .getData(props.payload?.config, value, props.payload?.section, "$input")
                                        .then((results: Array<IOption>) => {
                                            setOptions(results);
                                            setLoading(false);
                                        })
                                        .catch(() => {
                                            setOptions([]);
                                            setLoading(false);
                                            // props.context.handleError(error, props.section, props.name);
                                        });
                            }, 1000);
                            setPeriod(timeout);
                        }
                    }}
                    variant='outlined'
                />
            </Box>
            <List>
                <RadioGroup
                    row
                    value={props.payload?.value || ""}
                    onChange={(e) => {
                        const value = e.target.value;
                        let actualValue: string | number;
                        const parentLabel = e.target.closest("label");
                        const datatype = parentLabel ? parentLabel.getAttribute("datatype") : "";
                        if (datatype) {
                            switch (datatype) {
                                case "number":
                                    actualValue = parseInt(value);
                                    break;
                                default:
                                    actualValue = value;
                            }
                        } else {
                            actualValue = value;
                        }
                        const optionMatch = options.find((o) => o.value === actualValue);
                        props.handleChange(optionMatch, options);
                        handleClose();
                    }}
                >
                    {isLoading ? (
                        <Box
                            className='progress-loader'
                            sx={{
                                display: "flex",
                                width: "100%",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : options && options.length === 0 ? (
                        <Box
                            className='meta-no-data-wrapper'
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "center",
                                width: "100%",
                                height: "100%"
                            }}
                        >
                            <span className='meta-no-data'>No matches</span>
                        </Box>
                    ) : (
                        <VirtualScroll
                            className='list'
                            minItemHeight={50}
                            totalLength={options.length}
                            renderItem={(rowIndex: number) => {
                                const option = options[rowIndex];
                                const datatype = typeof option.value;
                                return (
                                    <ListItem button key={option.value} className='list-item'>
                                        <FormControlLabel datatype={datatype} value={option.value} control={<Radio />} label={option.label} />
                                    </ListItem>
                                );
                            }}
                        />
                    )}
                </RadioGroup>
            </List>
        </Dialog>
    );
};

interface IProps {
    payload: IModalPayload | undefined;
    open: boolean;
    onClose: Function;
    handleChange: Function;
}

export default MuiModal;
